import React, { useEffect, useState } from 'react';
import {Grid, Box, Modal, Typography, Checkbox, Button, LinearProgress, TextField} from "@mui/material";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styles } from "./styles";
import CloseIcon from '@mui/icons-material/Close';
import moment from "moment";
import FormControlLabel from '@mui/material/FormControlLabel';
import MuiSelect from "components/MuiSelect/MuiSelect";
import {
  addDevice,
  getAllDeviceTypes,
  getAllServiceProviders,
  getAllTrucks,
  editDevice,
  getSegment,
  getDeviceTraceById,
  getDeviceDetailsById, deleteDevice, getAvailableTrucks
} from 'apis/device';
import { getAllRoles } from 'apis/user';
import { Colors } from 'assets/colors';
import TruckMuiSelect from "../MuiSelect/TruckMuiSelect";
import CommonUtil from "../../common/CommonUtil";
import ToastManager from "../../common/ToastManager";
import DeleteModal from "../../common/DeleteModal";
import DisAssocModal from "../../common/DisAssocModal";

interface InputType {
  type: string,
  placeholder: string,
  disabled?: boolean,
  label?: string,
  size: number,
  key: string,
  onChange: any,
  value: string
}

interface SelectType {
  size: number
}

interface DeviceModalProps {
  open: boolean;
  handleClose: Function | any;
  getDeviceList: Function;
  deviceToEdit?: any;
}
var defaultDevice = {
  "application": "",
  "attribute1": "",
  "attribute2": "",
  "attribute3": "",
  "attribute4": "",
  "deviceId": "",
  "deviceStatus": "Active",
  "deviceTypeId": 1,
  "deviceTypeName": "",
  "isCameraConnected": false,
  "observation1Description": "",
  "observation2Description": "",
  "observation3Description": "",
  "segmentId": "",
  "serviceProviderId": "",
  "segmentName": "",
  "serviceProviderName": "",
  "truckId": ""
}

const defaultVal = {
createdBy: "",
creationDate: "",
deviceId: null,
iotDeviceId: null,
lastUpdateDate: "",
lastUpdatedBy: "",
segmentName : null,
serviceProviderName: "",
serviceType: "",
sfId : null,
timeZone : null,
truckId : null,
truckName : null,
truckStatus :  "",
truckType:  "",
warehouseLocationNAme : null
}

const DeviceModal: React.FC<DeviceModalProps> = ({ open, handleClose, getDeviceList, deviceToEdit }) => {
  const [device, setDevice] = useState(defaultDevice);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [types, setTypes] = useState<any>([]);
  const [applications, setApplications] = useState<any>([]);
  const [trucks, setTrucks] = useState<any>([]);
  const [truckOptions, setTruckOptions] = useState([]);
  const [currentTruckName, setCurrentTruckName] = useState<any>(null);
  const [currentServiceProvider, setCurrentServiceProvider] = useState<any>(null);
  const [currentServiceProviderError, setCurrentServiceProviderError] = useState(true);
  
  const [providers, setProviders] = useState([]);
  const [segments, setSegments] = useState([]);
  const [segmentError, setSegmentError] = useState('');
  const [currentSegment, setCurrentSegment] = useState<any>(null);
  const [currentSegmentError, setCurrentSegmentError] = useState(true);
  
  const [deviceId,setDeviceId] = useState("");
  const [deviceIdError, setDeviceIdError] = useState(true);
  const [deviceTypeName,setDeviceTypeName] = useState<any>(null);
  const [deviceTypeNameError, setDeviceTypeNameError] = useState(true);
  const [application,setApplication] = useState<any>(null);
  const [applicationError,setApplicationError] = useState(true);

  const [truckStatuses,setTruckStatuses] = useState(CommonUtil.statuses);
  const [deviceStatus,setDeviceStatus] = useState<any>(null);
  const [deviceStatusError,setDeviceStatusError] = useState(true);

  const [observation1Description,setObservation1Description] = useState("");
  const [observation2Description,setObservation2Description] = useState("");
  const [observation3Description,setObservation3Description] = useState("");

  const [attribute1,setAttribute1] = useState("");
  const [attribute2,setAttribute2] = useState("");
  const [attribute3,setAttribute3] = useState("");
  const [attribute4,setAttribute4] = useState("");
  const [isCameraConnected,setCameraConnected] = useState(false);
  const [delDevice,setDelDevice] = useState(false);
  const [disassocDevice,setDisassocDevice] = useState(false);
  const [deviceHistory, setDeviceHistory] = useState<any>([]);


//#448
// checks if there is a device being edited and waits for all data to be loaded
useEffect(() => {
  if (deviceToEdit !== null ) {
    console.log(deviceToEdit);
    getDeviceDetails();
  }
}, []);//deviceToEdit, segments, providers, types, applications, trucks



  let getDeviceDetails = async () => {
    let data = await getDeviceDetailsById(deviceToEdit.iotDeviceId);
    console.log(data);
    if (data?.response?.data?.errorMessage) {
      ToastManager.showToast(data.response.data.errorMessage,"Error");
     // setError(data.response.data.errorMessage);
      return
    }
    if (data) {
      setDeviceId(data.deviceId);
      setDeviceIdError(false)
      setDeviceTypeName({deviceTypeId:data.deviceTypeId,deviceTypeName:data.deviceTypeName});
      setDeviceTypeNameError(false);
      setDeviceStatus({key:data.deviceStatus,value:data.deviceStatus});
      setDeviceStatusError(false);
      setCurrentServiceProvider({id:data.serviceProviderId,name:deviceToEdit.serviceProviderNme});
      setCurrentServiceProviderError(false);
      setCurrentSegment({id:data.segmentId,name:deviceToEdit.segmentName});
      setCurrentSegmentError(false);
      getSegmentList(data.serviceProviderId);
      setCurrentTruckName({truckId:data.truckId,truckName:data.truckName});
      setApplication({applicationName:data.application});
      setApplicationError(false);
      setCameraConnected(data.isCameraConnected);
      setObservation1Description(data.observation1Description);
      setObservation2Description(data.observation2Description);
      setObservation3Description(data.observation3Description);
      setAttribute1(data.attribute1);
      setAttribute2(data.attribute2);
      setAttribute3(data.attribute3);
      setAttribute4(data.attribute4);
      getTrucks({segId:data.segmentId,serviceProvId:data.serviceProviderId});

    }
  }

  const getDeviceTypes = async () => {
    let data = await getAllDeviceTypes();
    if (data?.response?.data?.errorMessage) {
      setError(data.response.data.errorMessage);
      return
    }
    if (data && data[0]) {
      setTypes(data);

    }
  }

  const getServiceProviders = async () => {
    let data = await getAllServiceProviders();
    if (data?.response?.data?.errorMessage) {
      setError(data.response.data.errorMessage);
      return
    }
    if (data && data[0]) {
      setProviders(data);
      //setCurrentServiceProvider(data[0].name);

    }
  }

  const getUniqueApplicationNames = (objects: any) => {
    const uniqueNames: any = [];
    let apps = [];
    for (const obj of objects) {
      if (obj.hasOwnProperty('applicationName') && !uniqueNames.includes(obj.applicationName)) {
        uniqueNames.push(obj.applicationName);
      }
    }

    for(let x1=0;x1<uniqueNames.length;x1++){
      apps.push({applicationName:uniqueNames[x1]});
    }
    return apps;
  }

  const getRoles = async () => {
    let data = await getAllRoles();
    if (data?.response?.data?.errorMessage) {
      setError(data.response.data.errorMessage);
      return
    }
    if (data) {
      let filtered = getUniqueApplicationNames(data);
      console.log(filtered);
      setApplications(filtered);
    }
  }

  const getTrucks = async (input : any) => {
    // let data = await getAllTrucks()
    if(input && input.serviceProvId && input.segId) {
      let data =  await getAvailableTrucks(input.segId,input.serviceProvId); 
      console.log(data)
      if (data?.response?.data?.errorMessage) {
        setError(data.response.data.errorMessage);
        return
      }
      if (data && data.length > 0) {
        let newData = data.filter(function (obj:any) {
          return obj.serviceType === 'Collection Truck';
        });
        setTrucks(newData);
      }
    }
  }

 // to fetch device field history
  const getHistory = async () => {
    var dataHistory = await getDeviceTraceById(deviceToEdit.iotDeviceId);
    if (dataHistory?.response?.data?.errorMessage) {
      setError(dataHistory.response.data.errorMessage);
      return
    }
    if(dataHistory){
      setDeviceHistory(dataHistory);
    }
  }
 // console.log(deviceHistory)
  useEffect(() => {
    getHistory();
  }, [])

  const getAllData = () => {
    setIsLoading(true);
    Promise.all([getDeviceTypes(), getServiceProviders(), getRoles(), getTrucks({segId:currentSegment,serviceProvId:currentServiceProvider})]);
    setIsLoading(false);
  }

  useEffect(() => {
    getAllData();
  }, []);


  // calls api for list of segments based on service provider id
  const getSegmentList = async (id: string) => {
    let data = await getSegment(id);

    if (data?.response?.data?.error) {
      setSegmentError("No Segment found with Service provider");
      return
    }
    if (data) {
      setSegments(data);
      //setCurrentSegment(data[0].name);
      //setSegmentError("");

    }
  }

  // checks change of provider to grab the id to pass to the device post obj and grab id to get list of segments


   // checks change of segment to grab the id to pass to the device post obj




  const returnInput = (params: InputType) => {
    let { type, placeholder, disabled, label, value, key, onChange } = params;
    return (
      <Grid item xs={params.size} sx={styles.inputContainer}>
        {label && <Typography sx={styles.label}>{label}</Typography>}
        {type === "input" ?
          <input
            type="text"
            placeholder={placeholder}
            value={value}
            style={styles.input}
            disabled={disabled ? disabled : false}
            onChange={(e) => onChange(e.target.value, key)}
          />
          :
          <textarea value={value} onChange={(e) => onChange(e.target.value, key)} style={styles.textarea} placeholder={placeholder} maxLength={100}></textarea>
        }
      </Grid>
    )
  }

  const handleInputChange = (val: any, key: string) => {
    setDevice({ ...device, [key]: val })
  };

  let getRequestObject = ()=>{
    if(!deviceId){
      setDeviceIdError(true);
    }
    if(!deviceTypeName){
      setDeviceTypeNameError(true);
    }
    if(!deviceStatus){
      setDeviceStatusError(true);
    }
    if(!currentServiceProvider){
      setCurrentServiceProviderError(true);
    }
    if(!currentSegment){
      setCurrentSegmentError(true);
    }
    if(!application){
      setApplicationError(true);
    }
   if(deviceId && deviceTypeName && deviceStatus && currentServiceProvider && currentSegment && application){
    var reqObj:any = {};
    reqObj.application = application?application.applicationName:"";
    reqObj.attribute1 = attribute1;
    reqObj.attribute2 = attribute2;
    reqObj.attribute3 = attribute3;
    reqObj.attribute4 = attribute4;
    reqObj.deviceId = deviceId;
    reqObj.deviceStatus = deviceStatus?deviceStatus.value:"";
    reqObj.deviceTypeId = deviceTypeName?deviceTypeName.deviceTypeId:"";
    reqObj.isCameraConnected = isCameraConnected;
    reqObj.observation1Description = observation1Description;
    reqObj.observation2Description = observation2Description;
    reqObj.observation3Description = observation3Description;
    reqObj.segmentId = currentSegment?currentSegment.id:"";
    reqObj.segmentName = currentSegment?currentSegment.name:"";
    reqObj.serviceProviderId = currentServiceProvider?currentServiceProvider.id:"";
    reqObj.serviceProviderName = currentServiceProvider?currentServiceProvider.name:"";
    reqObj.truckId = currentTruckName?currentTruckName.truckId:"";
    return reqObj;
   }
   return null;
  }

  const handleAddDevice = async () => {

    let reqObj = getRequestObject();
    console.log(reqObj);

    let data = await addDevice(reqObj);
    if (data?.response?.data?.errorMessage) {
     // setError(data.response.data.errorMessage);
     if(data?.response?.data?.errorMessage === "Content type 'application/x-www-form-urlencoded;charset=UTF-8' not supported"){
      ToastManager.showToast("Please fill required fields", "Error");
      return;
     }
      ToastManager.showToast(data.response.data.errorMessage, "Error");
      return;
    }
    if (data) {
      console.log(data)
      handleClose(false);
      getDeviceList();
      ToastManager.showToast("Device Created Successfully","Success");
    }
   /* if(device.deviceId === "") {
      setError("Device Name is required");
    } else {
      console.log(device)
      let data = await addDevice(device);
      if (data?.response?.data?.errorMessage) {
        setError(data.response.data.errorMessage);
        return;
      }
      if (data) {
        console.log(data)
        handleClose(false);
        getDeviceList();
      }
    }*/
  }

  const handleEditDevice = async () => {
    let reqObj = getRequestObject();
    reqObj.iotDeviceId = deviceToEdit.iotDeviceId;
    console.log(reqObj);

    let data = await editDevice(reqObj);
    if (data?.response?.data?.errorMessage) {
      ToastManager.showToast(data.response.data.errorMessage,"Error");
      return;
    }
    if (data) {
      handleClose(false);
      getDeviceList();
      ToastManager.showToast("Device Updated Successfully","Success");
    }
  }



  const handleTypeChange = (val: string) => {
    let filtered: any = types.filter((t: any) => t.deviceTypeName === val);
    if (filtered.length > 0) {
      setDevice({ ...device, deviceTypeName: val, deviceTypeId: filtered[0].deviceTypeId });
    }
  }

  const handleTruckName = (val: string) => {
    let filtered = trucks.filter((t: any) => t.truckName === val);
    console.log(filtered);
    if(filtered.length > 0) {
      //setCurrentTruckName(val);
      setDevice({...device, truckId: filtered[0].truckId});
    }
  }

  const onChangeDeviceId = (data:any)=>{
    setDeviceId(data);
    if(data){
      setDeviceIdError(false);
    }else{
      setDeviceIdError(true);
    }
  }
  const onChangeDeviceType = (data:any)=>{
    setDeviceTypeName(data);
    if(data){
      setDeviceTypeNameError(false);
    }
    else{
      setDeviceTypeNameError(true);
    }
  }
  const onChangeStatus = (data:any)=>{
    setDeviceStatus(data);
    if(data){
      setDeviceStatusError(false);
    }
    else{
      setDeviceStatusError(true);
    }
  }
  const onChangeServiceProvider = (data:any)=>{
    setCurrentServiceProvider(data);
    setSegments([]);
    setCurrentSegment(null);
    setTrucks([]);
    setCurrentTruckName(null);
    if(data){
      getSegmentList(data.id);
      setCurrentServiceProviderError(false);
    }
    else{
      setCurrentServiceProviderError(true);
    }

  }
  const onChangeSegment = (data:any)=>{
    setCurrentSegment(data);
    setTrucks([]);
    setCurrentTruckName(null);
    if(data){
      getTrucks({segId:data.id,serviceProvId:currentServiceProvider.id});
      setCurrentSegmentError(false);
    }else{
      setCurrentSegmentError(true);
    }
  }
  const onChangeApplication = (data:any)=>{
    setApplication(data);
    if(data){
      setApplicationError(false);
    }else{
      setApplicationError(true);
    }
  }
  let onChangeTruck = (data:any)=>{
    setCurrentTruckName(data);
  }
  let onChangeObserv1Desc = (data:any)=>{
    setObservation1Description(data);
  }
  let onChangeObserv2Desc = (data:any)=>{
    setObservation2Description(data);
  }
  let onChangeObserv3Desc = (data:any)=>{
    setObservation3Description(data);
  }

  let onChangeAttribute1 = (data:any)=>{
    setAttribute1(data);
  }

  let onChangeAttribute2 = (data:any)=>{
    setAttribute2(data);
  }

  let onChangeAttribute3 = (data:any)=>{
    setAttribute3(data);
  }

  let onChangeAttribute4 = (data:any)=>{
    setAttribute4(data);
  }
  let onClickDeleteDevice = ()=>{
    setDelDevice(true);
  }
  let handleDeleteDevice = async(dev:any)=>{
    console.log(dev);
    if(dev && dev.iotDeviceId){
      let data = await deleteDevice(dev.iotDeviceId);
      if (data?.response?.data?.errorMessage) {
        ToastManager.showToast(data.response.data.errorMessage,"Error");
        return;
      }
      if (data) {
        ToastManager.showToast("Device Deleted Successfully","Success");
        handleClose(false);
        getDeviceList();

      }
    }

  }
  let setDeleteDevice = ()=>{
    setDelDevice(false);
  }

  let onClickDisassociation = ()=>{
    setDisassocDevice(true);
  }
  let handleDisassocDevice = ()=>{
    setDisassocDevice(false);
  }
  let getList = ()=>{

  }

  let handleDisassociationDevice = (dev:any)=>{
    console.log(dev);
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <>
        {delDevice && <DeleteModal title={"Delete Device"} open={delDevice} handleDelete={handleDeleteDevice} handlePopupClose={setDeleteDevice} role={deviceToEdit} getList={getList} />}
        {disassocDevice && <DisAssocModal title={"Device Association Device"} open={disassocDevice} handleDelete={handleDisassociationDevice} handlePopupClose={handleDisassocDevice} role={deviceToEdit} getList={getList} />}
        <Box sx={styles.container}>
          {isLoading && <LinearProgress sx={{ margin: ".5rem 0" }} />}
          {error !== "" && <Typography sx={{ color: "red", fontSize: ".7rem" }}>{error}</Typography>}
          <Grid item xs={12} sx={styles.header}>
            <h2>{deviceToEdit !== null ? "Edit Device" : "Add Device"}</h2>
            <CloseIcon onClick={() => handleClose(false)} />
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography sx={styles.subHeader} style={{ fontWeight: "bold", marginTop: "0px" }}>Device Details</Typography>
              <Grid container spacing={2} sx={styles.subContainer}>
                <Grid item xs={6}>
                  <TextField style={{ width: "100%", paddingBottom: "0px" }} label={"Device ID"} value={deviceId} inputProps={{ maxLength: 20 }}
                    onChange={(e) => onChangeDeviceId(e.target.value)} required={true} error={deviceIdError} />
                  {/*returnInput({ type: "input", placeholder: "Device ID", size: 12, key: "deviceId", value: device.deviceId, onChange: handleInputChange })*/}
                </Grid>

                <Grid item xs={6} sx={{ marginBottom: 0 }}>
                  <TruckMuiSelect label={"Device Type"} sKey={"deviceTypeId"} value={"deviceTypeName"} selectedValue={deviceTypeName} dataSource={types}
                    mandatory={true} iserror={deviceTypeNameError} onChangeHandler={(e: any) => onChangeDeviceType(e)} />
                  {/*<MuiSelect value={device.deviceTypeName} options={types.map((t: any) => t.deviceTypeName)} onChangeHandler={(e: any) => handleTypeChange(e)} />*/}
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={styles.subContainer}>
                <Grid item xs={6} sx={{ marginBottom: 0 }}>
                  <TruckMuiSelect label={"Status"} sKey={"key"} value={"value"} selectedValue={deviceStatus} dataSource={truckStatuses}
                    mandatory={true} iserror={deviceStatusError} onChangeHandler={(e: any) => onChangeStatus(e)} />
                  {/*<MuiSelect value={device.deviceStatus} options={["Active", "Inactive"]} onChangeHandler={(e: any) => setDevice({ ...device, deviceStatus: e })} />*/}
                </Grid>
                <Grid item xs={6} sx={{ marginBottom: 0 }}>
                  <TruckMuiSelect label={"Service Provider Name"} sKey={"id"} value={"name"} selectedValue={currentServiceProvider} dataSource={providers}
                    mandatory={true} iserror={currentServiceProviderError} onChangeHandler={(e: any) => onChangeServiceProvider(e)} disabled={ deviceToEdit !== null && currentTruckName !== null && currentTruckName.truckId ? true : false}/>
                  {/*<MuiSelect value={currentServiceProvider} options={providers.map(((p: any) => p.name))} onChangeHandler={(e: any) => setCurrentServiceProvider(e)} />*/}
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={styles.subContainer}>
                <Grid item xs={6} sx={{ marginBottom: 0 }}>
                  <TruckMuiSelect label={"Segment"} sKey={"id"} value={"name"} selectedValue={currentSegment} dataSource={segments}
                    mandatory={true} iserror={currentSegmentError} onChangeHandler={(e: any) => onChangeSegment(e)} disabled={ deviceToEdit !== null && currentTruckName !== null && currentTruckName.truckId ? true : false}/>
                  {/*<MuiSelect value={currentSegment} options={segments.map(((p: any) => p.name))} onChangeHandler={(e: any) => setCurrentSegment(e)} />*/}
                  {segmentError !== "" && <Typography sx={{ color: "red", fontSize: ".7rem" }}>{segmentError}</Typography>}
                </Grid>
                <Grid item xs={6} sx={{ marginBottom: 0 }}>
                  <TruckMuiSelect label={"Application"} sKey={"applicationName"} value={"applicationName"} selectedValue={application} dataSource={applications}
                    mandatory={true} iserror={applicationError} onChangeHandler={(e: any) => onChangeApplication(e)} />
                  {/*<MuiSelect value={device.application} options={applications} onChangeHandler={(e: any) => setDevice({ ...device, application: e })} />*/}
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={styles.subContainer}>
                <Grid item xs={6} sx={{ marginBottom: 0 }}>
                  <TruckMuiSelect label={"Truck Number"} sKey={"truckId"} value={"truckName"} selectedValue={currentTruckName} dataSource={trucks}
                    mandatory={false} iserror={false} onChangeHandler={(e: any) => onChangeTruck(e)} />
                  {/*<MuiSelect value={currentTruckName} options={truckOptions} onChangeHandler={(e: any) => handleTruckName(e)} />*/}
                </Grid>
                <Grid item xs={6} sx={{ marginBottom: 0 }}>
                  <FormControlLabel control={<Checkbox checked={isCameraConnected} size="small" onChange={e => {setCameraConnected(e.target.checked); }}/>} label="Is Camera Connected?" />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Typography sx={styles.subHeader} style={{ fontWeight: "bold", marginTop: "0px", paddingBottom: "15px" }}>Observation Details (optional)</Typography>
              <Grid item xs={12} >
                <TextField style={{ width: "100%", paddingBottom: "15px" }} label={"Observation 1 Description"} inputProps={{ maxLength: 120 }} value={observation1Description}
                  onChange={(e) => onChangeObserv1Desc(e.target.value)} required={false} error={false} multiline={true} />
                <TextField style={{ width: "100%", paddingBottom: "15px" }} label={"Observation 2 Description"} inputProps={{ maxLength: 120 }} value={observation2Description}
                  onChange={(e) => onChangeObserv2Desc(e.target.value)} required={false} error={false} multiline={true} />
                <TextField style={{ width: "100%", paddingBottom: "15px" }} label={"Observation 3 Description"} inputProps={{ maxLength: 120 }} value={observation3Description}
                  onChange={(e) => onChangeObserv3Desc(e.target.value)} required={false} error={false} multiline={true} />
              </Grid>
              <Typography sx={styles.subHeader} style={{ fontWeight: "bold", marginTop: "10px", paddingBottom: "15px" }}>Attribute Details (optional)</Typography>
              <Grid item xs={12}>
                <TextField style={{ width: "100%", paddingBottom: "15px" }} label={"Attribute 1"} inputProps={{ maxLength: 64 }} value={attribute1}
                  onChange={(e) => onChangeAttribute1(e.target.value)} required={false} error={false} multiline={true} />
                <TextField style={{ width: "100%", paddingBottom: "15px" }} label={"Attribute 2"} inputProps={{ maxLength: 64 }} value={attribute2}
                  onChange={(e) => onChangeAttribute2(e.target.value)} required={false} error={false} multiline={true} />
                <TextField style={{ width: "100%", paddingBottom: "15px" }} label={"Attribute 3"} inputProps={{ maxLength: 64 }} value={attribute3}
                  onChange={(e) => onChangeAttribute3(e.target.value)} required={false} error={false} multiline={true} />
                <TextField style={{ width: "100%", paddingBottom: "15px" }} label={"Attribute 4"} inputProps={{ maxLength: 64 }} value={attribute4}
                  onChange={(e) => onChangeAttribute4(e.target.value)} required={false} error={false} multiline={true} />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sx={styles.buttonContainer}>
            <Button sx={styles.cancelButton} onClick={() => handleClose(false)}>Cancel</Button>
            {(deviceToEdit !== null && CommonUtil.isScreenButtonAvailable(CommonUtil.DEVICE_MANAGER,CommonUtil.UPDATE_MODE))? <Button sx={styles.deleteButton} onClick={onClickDeleteDevice}>Delete</Button>:""}
            {(deviceToEdit !== null && CommonUtil.isScreenButtonAvailable(CommonUtil.DEVICE_MANAGER,CommonUtil.UPDATE_MODE))?<Button sx={styles.addButton} onClick={handleEditDevice}>{"Update"}</Button>:""}
            {(!deviceToEdit && CommonUtil.isScreenButtonAvailable(CommonUtil.DEVICE_MANAGER,CommonUtil.UPDATE_MODE))?<Button sx={styles.addButton} onClick={handleAddDevice}>{"Save"}</Button>:""}

          </Grid>
          <Grid item xs={12}>
          <Typography sx={styles.subHeader} style={{fontWeight:"bold",marginTop:"20px"}}>Device History</Typography>
          <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell sx={styles.Cell}>Change Type</TableCell>
            <TableCell sx={styles.Cell}>Changed On</TableCell>
            <TableCell sx={styles.Cell}>Field Changed</TableCell>
            <TableCell sx={styles.Cell}>Value Before Change</TableCell>
            <TableCell sx={styles.Cell}>Value After Change</TableCell>
            <TableCell sx={styles.Cell}>Changed By</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        <TableRow>
              <TableCell sx={styles.Cell}>Creation</TableCell>
              <TableCell sx={styles.Cell}>{deviceToEdit !== null && deviceToEdit.creationDate}</TableCell>
              <TableCell sx={styles.Cell}></TableCell>
              <TableCell sx={styles.Cell}></TableCell>
              <TableCell sx={styles.Cell}></TableCell>
              <TableCell sx={styles.Cell}>{deviceToEdit !== null && deviceToEdit.createdBy}</TableCell>
          </TableRow>
            {deviceHistory && deviceHistory.map((item: any, i: any) => {
              return (
              <TableRow key={i}>
              <TableCell sx={styles.Cell}>Update</TableCell>
              <TableCell sx={styles.Cell}>{item.changeDate && item.changeDate.includes('+0000') && moment.parseZone(new Date(item.changeDate)).utc().format('MM/DD/YYYY h:mm:ss A')}</TableCell>
              <TableCell sx={styles.Cell}>{item.changedField}</TableCell>
              <TableCell sx={styles.Cell}>{item.fromValue}</TableCell>
              <TableCell sx={styles.Cell}>{item.toValue}</TableCell>
              <TableCell sx={styles.Cell}>{deviceToEdit.lastUpdatedBy}</TableCell>
              </TableRow>

              )
            })}

        </TableBody>
      </Table>
    </TableContainer>
          </Grid>
        </Box>
      </>
    </Modal>
  )
}

export default DeviceModal;
